var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "single-column",
    [
      _c("div", { staticClass: "va-title d-flex justify-space-between" }, [
        _vm._v(" " + _vm._s(_vm.$t("roomWizard.newRoom")) + " ")
      ]),
      _vm.deviceConfiguration == undefined
        ? _c("wizard-connect", {
            on: {
              onFetchConfiguration: function($event) {
                _vm.deviceConfiguration = $event
              }
            }
          })
        : _c("room-wizard", {
            attrs: {
              steps: _vm.steps,
              "device-configuration": _vm.deviceConfiguration
            },
            on: { configUpdated: _vm.onConfigUpdated }
          }),
      _c(
        "div",
        { staticClass: "d-flex justify-right mt-6" },
        [
          _vm.deviceConfiguration != undefined
            ? _c("va-button", {
                attrs: {
                  cta: _vm.$t("roomWizard.reset"),
                  disabled: _vm.deviceConfiguration == undefined
                },
                on: {
                  click: function($event) {
                    _vm.deviceConfiguration = undefined
                  }
                }
              })
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }